// Import the functions you need from the SDKs you need
import { initializeApp } from 'firebase/app';
//import { getFirestore } from 'firebase/firestore';
import { getDatabase, connectDatabaseEmulator } from 'firebase/database';
import { getFirestore, connectFirestoreEmulator } from 'firebase/firestore';
import { getStorage, connectStorageEmulator } from 'firebase/storage';
import { getAuth, connectAuthEmulator } from 'firebase/auth';

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries
// Your web app's Firebase configuration

let firebaseConfig;
if (window.location.hostname === 'localhost') {
  firebaseConfig = {
    apiKey: 'AIzaSyB8K2OIzR6oYjG86XLOSvTuVQEQ86HxkO8',
    authDomain: 'monarch-24.firebaseapp.com',
    databaseURL: 'https://monarch-24-default-rtdb.firebaseio.com',
    projectId: 'monarch-24',
    storageBucket: 'monarch-24.appspot.com',
    messagingSenderId: '22230311528',
    appId: '1:22230311528:web:20039f72d0759924c351dd',
    measurementId: 'G-6GRGBVS0B3',
  };
} else {
  firebaseConfig = {
    apiKey: 'AIzaSyDtDGCQ0SEcK6Zr0QB6mYoNc_01o2e3REk',
    authDomain: 'knowledgefordev-38043.firebaseapp.com',
    databaseURL: 'https://knowledgefordev-38043-default-rtdb.firebaseio.com',
    projectId: 'knowledgefordev-38043',
    storageBucket: 'knowledgefordev-38043.appspot.com',
    messagingSenderId: '958088906799',
    appId: '1:958088906799:web:54e4d0dbe85398d4b05eda',
    measurementId: 'G-NX86R028MH',
  };
}
// Initialize Firebase

export const app = initializeApp(firebaseConfig);
// Export firestore database
// It will be imported into your react app whenever it is needed
//export const db = getFirestore(app);
const db = getDatabase();
try {
  if (window.location.hostname === 'localhost') {
    // Point to the RTDB emulator running on localhost.
    connectDatabaseEmulator(db, '127.0.0.1', 9000);
  }
} catch (IllegalStateException) {}
/*https://firebase.google.com/docs/emulator-suite/connect_firestore*/
const store = getFirestore();
const storage = getStorage();
const auth = getAuth();
try {
  if (window.location.hostname === 'localhost') {
    // Point to the RTDB emulator running on localhost.
    connectFirestoreEmulator(store, '127.0.0.1', 8080);
    connectStorageEmulator(storage, '127.0.0.1', 9199);
    connectAuthEmulator(auth, 'http://127.0.0.1:9099');
  }
} catch (IllegalStateException) {}
export { db, store, storage, auth };

/*https://firebase.google.com/docs/emulator-suite/connect_rtdb#web-modular-api



*/
